import React from 'react';
import styled from 'styled-components';

const P = styled.p`
    color: var(--accent);
    font-size: ${11/12.6}rem;
    line-height: 1.2;
    padding: 1em 0 0;
    margin: 0 !important;

    body.theme-market &,
    body.theme-platinum & { color: var(--primary); }
`;

class Hint extends React.PureComponent {
    render() {
        return <P {...this.props}>{this.props.children}</P>;
    }
}

export default Hint;